const el = document.getElementById('wrightSocket')
el && el.parentNode.removeChild(el)

import './p.js'
import './ubre.js'
// import './inspect.js'
import './catcher.js'
